import { useState, useCallback, useMemo } from 'react';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { useHistory } from 'react-router-dom';


export const useReportExamsIncomplete = () => {

    const [listExamsIncomplete, setListExamsIncomplete] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectMachineModels, setSelectMachineModels] = useState([]);
    const [selectedMachine, setSelectedMachine] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [loadingExcel, setLoadingExcel] = useState(false);
    const history = useHistory();

    
    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");


    //#region ALERT GLOBAL 
    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };

    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };

    //#endregion

    //#region MACHINE MODELS
    const getMachineModels = useCallback(async () => {

        let requestOptions = {
            method: 'GET',
        };

        const respuesta = await sendRequest( requestOptions,"MachineModel/List");

        if (respuesta.code === 200) {
            let new_array = [];
            (respuesta.data || []).forEach(element => {

                new_array.push({
                    value: element.id_machine_model,
                    label: `${element.brand} ${element.model}`,
                    name: `${element.brand} ${element.model}`,
                });

            });

            setSelectMachineModels(new_array);

        }
        else if (respuesta.code === 401) {

            validarSesion(
                history,
                respuesta.code,
                getMachineModels
            );

        }
        else if (respuesta.code === 500) {
            showToastAlert("error", "Máquinas", "Ocurrió un problema al obtener las máquinas");
        }
        else {
            showToastAlert("warning", "Máquinas", respuesta.data?.msg);
        }

    }, [history]);

    //#endregion

    //#region Get Exams Incomplete

    const getExamsIncomplete = useCallback(async (idMachineModel = null) => {

        setLoading(true);
        let requestOptions = {
            method: 'GET'
        };

        let endpoint = "Exam/ReportMachineExamIncomplete";
        if (idMachineModel) {
            endpoint += `?ids_machine_models=${idMachineModel}`;
        }

        const respuesta = await sendRequest(requestOptions, endpoint);

        if (respuesta.code === 200) {

            setListExamsIncomplete(
                respuesta.data || []
            );
        }

        else if (respuesta.code === 401) {
            validarSesion( history, respuesta.code, () => getExamsIncomplete(idMachineModel));
        }

        else if (respuesta.code === 500) {
            showToastAlert("error", "Reporte de exámenes", "Ocurrió un problema en el servidor");
        }

        else {
            showToastAlert("warning", "Reporte de exámenes", respuesta.data?.msg);
        }
        setLoading(false);

    }, [history]);

    //#endregion

    //#region SEARCH
    const filteredExamsIncomplete = useMemo(() => {

        if (!searchText.trim()) {
            return listExamsIncomplete;
        }

        const search = searchText.toLowerCase().trim();

        return listExamsIncomplete.filter(item => {

            const exam = `${item.code_exam || ""} ${item.name_exam || ""}`.toLowerCase();

            const machine = (
                item.name_machine_model || ""
            ).toLowerCase();

            const method = (
                item.name_method || ""
            ).toLowerCase();

            const alert = (
                item.label_error || ""
            ).toLowerCase();

            return (
                exam.includes(search) ||
                machine.includes(search) ||
                method.includes(search) ||
                alert.includes(search)
            );

        });

    }, [listExamsIncomplete, searchText]);
    

    //endregion

    //#region EXCEL
    const downloadExcel = async () => {
        try {
            setLoadingExcel(true);
            const data = filteredExamsIncomplete;
            if (!data || data.length === 0) {
                showToastAlert("warning", "Reporte de exámenes", "No hay información para exportar");
                return;
            }

            const headers = [ "Exámen", "Máquina", "Método", "Alerta"];
            const rows = data.map(item => [
                `${item.code_exam || ""} ${item.name_exam || ""}`.trim(),
                item.name_machine_model || "",
                item.name_method || "",
                item.label_error || ""

            ]);

            const csv = [
                headers,
                ...rows
            ]
                .map(row =>
                    row
                        .map(value =>
                            `"${String(value).replace(/"/g, '""')}"`
                        )
                        .join(",")
                )
                .join("\n");

            const blob = new Blob(
                ["\ufeff" + csv],
                {
                    type: "text/csv;charset=utf-8;"
                }
            );

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
                "download",
                "Reporte de examenes incompletos.csv"
            );

            document.body.appendChild(link);
            link.style.display = "none";
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            showToastAlert("error", "Reporte de exámenes", "Ocurrió un problema al generar el archivo");
        }
        finally {
            setLoadingExcel(false);
        }
    };
    //#endregion


    return {

        listExamsIncomplete,
        getExamsIncomplete,
        loading,
        selectMachineModels,
        selectedMachine,
        setSelectedMachine,
        getMachineModels,
        
        filteredExamsIncomplete, searchText, setSearchText,

        downloadExcel, loadingExcel,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,
        

    };

};